import React, { useState, useEffect } from 'react';
import styles from './CountdownTimer.module.css';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const CountdownTimer: React.FC = () => {
  // Set the target date to July 22, 2025, 21:00 (9 PM)
  const targetDate = new Date('2025-07-22T21:00:00+02:00');
  const now = new Date();
  const distance = targetDate.getTime() - now.getTime();

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days,
    hours,
    minutes,
    seconds
  });

  useEffect(() => {
    // Set the target date to July 22, 2025, 21:00 (9 PM)
    const targetDate = new Date('2025-07-22T21:00:00+02:00');

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance < 0) {
        // Timer has expired
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    // Cleanup timer
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles['countdown-timer']}>
      <div className={styles['countdown-container']}>
        <div className={styles['countdown-item']}>
          <span className={styles['countdown-value']}>{timeLeft.days}</span>
          <span className={styles['countdown-label']}>Days</span>
        </div>
        <div className={styles['countdown-item']}>
          <span className={styles['countdown-value']}>{timeLeft.hours}</span>
          <span className={styles['countdown-label']}>Hours</span>
        </div>
        <div className={styles['countdown-item']}>
          <span className={styles['countdown-value']}>{timeLeft.minutes}</span>
          <span className={styles['countdown-label']}>Minutes</span>
        </div>
        <div className={styles['countdown-item']}>
          <span className={styles['countdown-value']}>{timeLeft.seconds}</span>
          <span className={styles['countdown-label']}>Seconds</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
